import { createApiClient, getAuthApiBaseUrl } from "./apiClientFactory";

const authApi = createApiClient({
	getBaseURL: getAuthApiBaseUrl,
	service: "auth"
});

export default authApi;
